// College Club Challenge line-up.
//
// The crests are REAL club artwork served from `public/league-clubs/`. Nothing
// in the app draws a university mark: an earlier hand-drawn shield shipped the
// UT mark reversed ("TU"), so the abbreviation below is only ever a text
// fallback, and no crest is rendered through a negative scale (see ClubShield).
//
// Dropping a file into public/league-clubs/ is all it takes to swap a crest —
// each club lists its candidate sources in priority order and the first one
// that loads wins, so png / svg / webp all work with no code change.
const sources = (id) => [
  `/league-clubs/${id}.png`,
  `/league-clubs/${id}.svg`,
  `/league-clubs/${id}.webp`,
];

export const CLUB_SHOWDOWN = {
  left: {
    id: "usf",
    abbr: "USF",
    name: "University of South Florida",
    accent: "#006747",
    sources: sources("usf"),
  },
  right: {
    id: "ut",
    abbr: "UT",
    name: "University of Texas",
    accent: "#BF5700",
    sources: sources("ut"),
  },
};

// Showdown angle: the crests lean INTO each other — left crest tips clockwise,
// right crest counter-clockwise, both pivoting on their bottom edge so they
// stay planted on the same baseline. Flip the signs to fan them outwards.
//
// Client Rev 4: "Rotate the left shield about 8 degrees clockwise toward the
// center. Rotate the right shield about 8 degrees counterclockwise toward the
// center." The lean direction was already right; only the angle moved.
// Client Rev 5: "Keep both shields vertically upright. Do not rotate or lean
// either shield sideways. Instead, apply a subtle inward 3D perspective so the
// shields appear to face one another... The effect should be subtle. Both
// shields should still read as straight and upright from a distance, but up
// close they should feel slightly turned toward one another."
//
// So this is no longer a lean (a Z rotation) but a turn about the vertical axis,
// applied under a perspective. Degrees of rotateY, positive for the LEFT crest:
// measured in the browser, +rotateY brings the LEFT edge forward and pushes the
// RIGHT edge back, which is exactly the client's instruction for USF ("push the
// right inner edge slightly backward... bringing the left outer edge slightly
// forward"). The right crest gets the negation.
export const SHOWDOWN_TURN = 16;

// How deep the vanishing point sits. Small enough that 16 degrees actually reads
// as depth on a ~96px crest, large enough that nothing looks warped: the near
// edge renders about 5% larger than the far one.
export const SHOWDOWN_PERSPECTIVE = 300;
